import type { MinimalRailShell } from "~/components/dock/minimalRailShell";

import { ApplicationEnum } from "~/@types/enums";
import buildMinimalRailShell from "~/components/dock/minimalRailShell";
import { type TranslateKey, translateWithActiveLanguage } from "~/helpers/localizedText";

const buildEngageRail = (translate: TranslateKey = translateWithActiveLanguage): MinimalRailShell =>
	buildMinimalRailShell(
		ApplicationEnum.ENGAGE,
		[
			{ icon: "add_circle_outline", id: "count", path: "/engage", title: translate("mobile:engage.rail.count") },
			{ icon: "history", id: "history", path: "/engage/history", title: translate("mobile:engage.rail.history") }
		],
		"storefront"
	);

export default buildEngageRail;
